import type { MomentInput } from 'moment'
import moment from 'moment'

function convertBreakToDate(
  shiftStart: MomentInput,
  breakStart: 'hh:mm' | string,
  breakEnd: 'hh:mm' | string
): { start: moment.Moment; end: moment.Moment } {
  const breakDates = {
    start: createBreakDateFromBreakTime(moment(shiftStart), breakStart),
    end: createBreakDateFromBreakTime(moment(shiftStart), breakEnd)
  }

  return breakDates
}

function createBreakDateFromBreakTime(
  shiftStart: moment.Moment,
  breakTime: string
) {
  const [breakHour, breakMin] = breakTime
    .split(':')
    .map(string => Number(string))

  return shiftStart
    .clone()
    .add(shiftStart.get('hours') > breakHour ? 1 : 0, 'days')
    .hours(breakHour)
    .minutes(breakMin)
    .seconds(0)
}

export default convertBreakToDate
